/* Per-component "Requires user login" flag.
 *
 * The flag lives on the DnD wrapper item (item.requiresLogin), NOT inside
 * item.component: the per-type forms re-emit their own data object on every
 * change and would silently drop a foreign field. It is merged into the
 * serialized component object at the single choke point where compId is
 * stamped (PostContainer's getComponentsArray) and read back out of the
 * stored component when a post is loaded for editing. */

// Stamps requiresLogin: true on the outgoing component object, or removes the
// key entirely when the item's checkbox is off — including a stale value the
// hydrated component may still carry from before the box was unchecked.
const applyRequiresLogin = (componentObj, requiresLogin) => {
  if (!componentObj || typeof componentObj !== 'object') return componentObj;
  if (requiresLogin === true) {
    componentObj.requiresLogin = true;
  } else {
    delete componentObj.requiresLogin;
  }
  return componentObj;
};

// Hydration: the wrapper item's checkbox state from a stored component.
const itemRequiresLogin = componentObj => Boolean(componentObj) && componentObj.requiresLogin === true;

module.exports = { applyRequiresLogin, itemRequiresLogin };
